import { render, staticRenderFns } from "./error-403-404.vue?vue&type=template&id=6b13ce7d&scoped=true"
import script from "./error-403-404.vue?vue&type=script&lang=js"
export * from "./error-403-404.vue?vue&type=script&lang=js"
import style0 from "./error-403-404.vue?vue&type=style&index=0&id=6b13ce7d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13ce7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b13ce7d')) {
      api.createRecord('6b13ce7d', component.options)
    } else {
      api.reload('6b13ce7d', component.options)
    }
    module.hot.accept("./error-403-404.vue?vue&type=template&id=6b13ce7d&scoped=true", function () {
      api.rerender('6b13ce7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-403-404.vue"
export default component.exports